var videoSubscriptionAppUrl = location.protocol + '//app.alexanderpublications.com/';//http://alexander-app.php.itrexgroup.com/

var attemptsSignOut = 0;
var signOutButton = $('.sign-out-instant-videos');
var signOutForm = $('.sign-out-form');

var attemptsSignIn = 0;
var signInButton = $('.sign-in-instant-videos');
var signInInput = $('.sign-in-input');
var signInInputInPopup = $('.vs-sign-in-popup-input');
var signInDiv = $('.div-sign-in-input');
var signInErrorDiv = $('.sign-in-error-div');
var signInForm = $('.sign-in-form');
var hasSignInError = false;

var myBody = $('body');

//var placeholderEmail = 'ENTER YOUR EMAIL ADDRESS';

//var submitMousedDownHappened = false;

var popupSelector = '.vs-sign-in-popup';

//$.support.cors = true;
//jQuery.support.cors = true;

var ie = (function () {

    var undef,
        v = 3,
        div = document.createElement('div'),
        all = div.getElementsByTagName('i');

    while (
        div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
            all[0]
        );

    return v > 4 ? v : undef;

}());

function setCookie(cname, cvalue) {//, exdays
    var d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));//exdays
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

function deleteCookie(cname) {
    document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}

function getErrorMessage($code) {
    switch ($code) {
        case 1:
            return 'That email is not found in our database.<br>Please try again.';
            break;
        case 2:
            return 'Email cannot be blank.';
            break;
        case 3:
            return 'Your subscription has expired. Please <a href="/products/subscription">re-subscribe</a>.';
            break;
        default:
            return 'Unexpected error';
    }
}

function signIn(viaPopup) {
    var viaPopup = viaPopup || false,
        email = viaPopup ? signInInputInPopup.val() : signInInput.val();
    email = $.trim(email);

    if (email != '') {// && email != placeholderEmail
        var isIE = (ie === 8 || ie === 9) ? 'yes' : 'no';
        $.ajax({
            crossDomain: true,
            cache: false,
            url: videoSubscriptionAppUrl + 'subscription/login?isIE=' + isIE,
            type: 'POST',
            data: {
                email: email
            },
            xhrFields: {
                withCredentials: true
            },
            success: function (response) {
                //console.log(response);
                //console.dir(response);
                var result = response.result;

                if (result) {

                    setCookie('vsuseremail', email);
                    // set Cookie for AMH as well
                    setCookie('amhuseremail', email);
                    setCookie('amhusertoken', response.token);

                    if (typeof(vsIsInstantProductPage) !== 'undefined' && vsIsInstantProductPage) {
                        location.reload();
                    } else {
                        var http = location.protocol;
                        var slashes = http.concat("//");
                        var host = slashes.concat(window.location.hostname);
                        window.location.href = host + "/products/subscription";
                    }
                } else if (ie === 8 || ie === 9) {
                    var errorCode = response.errorCode;
                    if (viaPopup) {
                        showSignInErrorInPopup(errorCode);
                    } else {
                        showSignInError(errorCode);
                    }
                } else {
                    alert('Unknown error. Please try again or reload this page.');
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                //console.log(jqXHR);
                //console.dir(jqXHR);

                if (jqXHR.status == 403) {

                    attemptsSignIn = 0;

                    var error = JSON.parse(jqXHR.responseText);

                    if (error.hasOwnProperty('errorCode')) {
                        if (viaPopup) {
                            showSignInErrorInPopup(error.errorCode);
                        } else {
                            showSignInError(error.errorCode);
                        }
                    }

                } else {
                    attemptsSignIn += 1;
                    if (attemptsSignIn < 2) {
                        setTimeout(signIn, 2000);
                    } else {
                        alert('Service is temporarily unavailable. Please try again later.');
                    }
                }


            }
        });
    }
}

function signOut() {
    $.ajax({
        url: videoSubscriptionAppUrl + 'subscription/logout',
        crossDomain: true,
        cache: false,
        xhrFields: {
            withCredentials: true
        },
        success: function (response) {
            var result = response.result;
            if (result) {
                deleteCookie('vsuseremail');
                // delete AMH Cookie as well
                deleteCookie('amhuseremail');
                deleteCookie('amhusertoken');
                if (ie === 8 || ie === 9) {
                    //else cookie will not be removed
                    location.reload();
                } else {
                    window.location.href = "/";
                }
            } else {
                alert('Unknown error. Please try again or reload this page.');
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            attemptsSignOut += 1;
            if (attemptsSignOut < 2) {
                setTimeout(signOut, 2000);
            } else {
                alert('Service is temporarily unavailable. Please try again later.');
            }
        }
    });
}

function isLogged() {
    $.ajax({
        url: videoSubscriptionAppUrl + 'subscription/is-logged',
        crossDomain: true,
        cache: false,
        xhrFields: {
            withCredentials: true
        },
        success: function (response) {
            //console.log(response);
            //console.dir(response);
            var isLogged = response.isLogged;
            var contin = true;

            //for browsers that doesn't support cookies via CORS, eg Internet Explorer 9 and lower.
            if (!isLogged) {// && (ie === 9 || ie === 8)
                var emailCookie = getCookie('vsuseremail');
                if (emailCookie !== '' && emailCookie !== null && emailCookie !== false) {

                    contin = false;

                    $.ajax({
                        crossDomain: true,
                        cache: false,
                        url: videoSubscriptionAppUrl + 'subscription/login',
                        type: 'POST',
                        data: {email: emailCookie},
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function (response) {
                            var result = response.result;

                            if (result) {
                                isLogged = true;
                                drawSignOutForm();
                                drawPlayNowDiv(isLogged);
                                drawPlayNowDivOn4wayProductPage(isLogged);
                                hideTopOfSubscriptionPage();
                            } else if (typeof(isPreventAccessPage) != 'undefined' && isPreventAccessPage) {
                                preventAccess();
                            } else {
                                drawSignInForm();
                                drawPlayNowDiv(isLogged);
                                drawPlayNowDivOn4wayProductPage(isLogged);
                            }
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            drawSignInForm();
                            drawPlayNowDiv(false);
                        }
                    });
                }
            }

            if (contin) {
                if (isLogged) {
                    drawSignOutForm();
                    drawPlayNowDiv(isLogged);
                    drawPlayNowDivOn4wayProductPage(isLogged);
                    hideTopOfSubscriptionPage();
                } else if (typeof(isPreventAccessPage) != 'undefined' && isPreventAccessPage) {
                    preventAccess();
                } else {
                    drawSignInForm();
                    drawPlayNowDiv(isLogged);
                    drawPlayNowDivOn4wayProductPage(isLogged);
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            //console.log(jqXHR);
            //console.dir(jqXHR);
            drawSignInForm();
            drawPlayNowDiv(false);
        }
    });
}

function hideTopOfSubscriptionPage() {
    var top = $('.vs-subscription-product-section');
    if (top.length > 0) {
        top.hide();
    }
}

function drawSignInForm() {
    signInForm.removeClass('vs-hide');
    signOutForm.addClass('vs-hide');
}

function drawSignOutForm() {
    signOutForm.removeClass('vs-hide');
    signInForm.addClass('vs-hide');
}

function drawPlayNowDiv(isLogged) {
    var playNowDiv = $('.vs-instant-video-play-now-new');
    if (playNowDiv.length > 0) {

        if (!isLogged) {
            var subscriptionButtonDiv = $('.vs-subscription-button-div');
            playNowDiv.replaceWith(subscriptionButtonDiv.html());
        }

        playNowDiv.show().css({'visibility': 'visible'});
    }
}

function drawPlayNowDivOn4wayProductPage(isLogged) {
    var playNowButton = $('.way-play-instant-video');
    var subscribeDiv = $('.way-subscribe-instant-video');

    if (!isLogged) {
        if (playNowButton.length > 0) {
            playNowButton.remove();
        }

        if (subscribeDiv.length > 0) {
            subscribeDiv.css({'visibility': 'visible'});
        }
    } else {
        if (subscribeDiv.length > 0) {
            subscribeDiv.remove();
        }

        if (playNowButton.length > 0) {
            playNowButton.css({'display': 'block'});
        }
    }
}

function getWidthCenter(selector) {
    var selector = $(selector),
        wind = $(window);
    if (selector.length > 0) {
        selector.css(
            {
                'left': wind.outerWidth() / 2 - selector.outerWidth() / 2,
                'top': wind.outerHeight() / 2 - selector.outerHeight() / 2/* - 50*/
            });
    }
}

function showSignInPopup(popup_selector) {
    getWidthCenter(popup_selector);
    var popup = $(popup_selector);
    popup.show();
}

function hideSignInPopup(popup_selector) {
    var popup = $(popup_selector);
    popup.hide();
}

function preventAccess() {
    myBody.html('');
    window.location.replace('/');
}

function showSignInErrorInPopup(code) {
    var errorDiv = $('.error-in-popup');
    errorDiv.html(getErrorMessage(code)).show();
}

//function hideSignInErrorInPopup()
//{
//    var errorDiv = $('.error-in-popup');
//    errorDiv.hide();
//}


function showSignInError(code) {
    signInDiv.addClass('login-error');
    signInErrorDiv.find('div.sign-in-error-text').html(getErrorMessage(code));
    signInErrorDiv.show();
    hasSignInError = true;
}

//function hideSignInError()
//{
//    signInDiv.removeClass('login-error');
//    signInErrorDiv.hide();
//    signInErrorDiv.find('div.sign-in-error-text').html('');
//    hasSignInError = false;
//}

$(document).ready(function () {

    isLogged();

    signOutButton.on('click', function () {
        signOut();
    });

    signInForm.on('submit', function (e) {
        e.preventDefault();
        signIn(false);
    });

    signInButton.on('click', function () {
        $(this).closest('form').trigger('submit');
    });

    //signInButton.add(signInErrorDiv).on('mousedown', function(){
    //    submitMousedDownHappened = true;
    //});

    //signInInput.on('click', function(){
    //    var signInInputVal = $.trim(signInInput.val());
    //    if(signInInputVal == placeholderEmail || hasSignInError){
    //        signInInput.val('');
    //    }
    //});

    //signInInput.on('keydown', function(){
    //    if(hasSignInError){
    //        hideSignInError();
    //    }
    //});

    //signInInput.on('blur', function(){
    //    var signInInputVal = $.trim(signInInput.val());
    //    if(signInInputVal == ''){
    //        signInInput.val(placeholderEmail);
    //    }
//
    //    if(!submitMousedDownHappened){
    //        signInInput.val(placeholderEmail);
    //        hideSignInError();
    //    }else{
    //        $(this).focus();
    //        submitMousedDownHappened = false;
    //    }
    //});

    myBody.on('click', '.vs-sign-in-span', function () {
        showSignInPopup(popupSelector);
    });

    $('.vs-sign-in-popup-close').add('.vs-cancel').on('click', function () {
        hideSignInPopup(popupSelector);
    });

    //send sign in form in popup
    $(popupSelector).on('submit', function (e) {
        e.preventDefault();
        signIn(true);
    });

    $('.vs-submit').on('click', function (e) {
        $(this).closest('form').trigger('submit');
    });

});